/* Wellrobed wishlist: small browser-local wishlist, no third-party services. */
(() => {
  'use strict';
  const KEY = 'wellrobed-wishlist-v1';
  const HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg>';

  function readWishlist() {
    try {
      const data = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(data) ? data.filter(x => x && typeof x.handle === 'string') : [];
    } catch (_) { return []; }
  }
  function writeWishlist(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('wellrobed:wishlist-changed'));
      return true;
    } catch (_) { return false; }
  }
  function inWishlist(handle) {
    return readWishlist().some(item => item.handle === handle);
  }
  function syncHeader() {
    const hasItems = readWishlist().length > 0;
    document.querySelectorAll('[data-wellrobed-wishlist-count]').forEach(dot => {
      dot.hidden = !hasItems;
    });
    document.querySelectorAll('[data-wellrobed-wishlist-link]').forEach(link => {
      link.setAttribute('aria-label', hasItems ? 'Wishlist, saved items' : 'Wishlist');
    });
  }
  function currentProduct() {
    const el = document.getElementById('wellrobed-wishlist-current-product');
    if (!el || !el.dataset.handle) return null;
    return {
      handle: el.dataset.handle,
      title: el.dataset.title || 'Product',
      url: el.dataset.url || `/products/${encodeURIComponent(el.dataset.handle)}`,
      image: el.dataset.image || '',
      price: el.dataset.price || ''
    };
  }
  function syncSaveButton(button, product) {
    const saved = inWishlist(product.handle);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
    button.title = saved ? 'Remove from wishlist' : 'Add to wishlist';
    button.querySelector('span').textContent = saved ? 'Remove from wishlist' : 'Add to wishlist';
  }
  function attachProductButton() {
    const product = currentProduct();
    if (!product) return;

    // Horizon keeps the real Add to Cart button in .product-form-buttons.
    // Add a separate type=button alongside it, without replacing its form,
    // variant selection, stock checks, cart events, or accelerated checkout.
    document.querySelectorAll('product-form-component .product-form-buttons').forEach(formButtons => {
      if (formButtons.querySelector('[data-wellrobed-wishlist-save]')) return;
      const addButton = formButtons.querySelector('add-to-cart-component button[name="add"]') ||
                        formButtons.querySelector('button[name="add"]');
      if (!addButton) return;
      const addSlot = Array.from(formButtons.children).find(child => child.contains(addButton));
      if (!addSlot) return;

      formButtons.classList.add('wellrobed-product-buy-row');
      addSlot.classList.add('wellrobed-product-buy-row__add');

      const wrap = document.createElement('div');
      wrap.className = 'wellrobed-wishlist-save-wrap';
      const button = document.createElement('button');
      button.type = 'button'; // Must not submit the product form.
      button.className = 'wellrobed-wishlist-save';
      button.setAttribute('data-wellrobed-wishlist-save', '');
      button.innerHTML = `${HEART}<span class="visually-hidden"></span>`;
      syncSaveButton(button, product);
      button.addEventListener('click', () => {
        const items = readWishlist();
        const next = items.some(item => item.handle === product.handle)
          ? items.filter(item => item.handle !== product.handle)
          : [...items, product];
        if (!writeWishlist(next)) {
          alert('Wishlist storage is unavailable in this browser.');
          return;
        }
        syncSaveButton(button, product);
      });
      wrap.appendChild(button);
      addSlot.insertAdjacentElement('afterend', wrap);
    });
  }
  function productCard(p) {
    const article = document.createElement('article');
    article.className = 'wellrobed-wishlist-card';
    const anchor = document.createElement('a');
    anchor.href = p.url || `/products/${encodeURIComponent(p.handle)}`;
    if (p.image) {
      const img = document.createElement('img');
      img.src = p.image;
      img.alt = p.title || 'Product';
      img.loading = 'lazy';
      img.className = 'wellrobed-wishlist-card__image';
      anchor.appendChild(img);
    } else {
      const placeholder = document.createElement('div');
      placeholder.className = 'wellrobed-wishlist-card__placeholder';
      placeholder.textContent = 'Image unavailable';
      anchor.appendChild(placeholder);
    }
    article.appendChild(anchor);
    const title = document.createElement('a');
    title.className = 'wellrobed-wishlist-card__title';
    title.href = anchor.href;
    title.textContent = p.title || 'Product';
    article.appendChild(title);
    if (p.price) {
      const price = document.createElement('div');
      price.className = 'wellrobed-wishlist-card__price';
      price.textContent = p.price;
      article.appendChild(price);
    }
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'wellrobed-wishlist-remove';
    remove.textContent = 'Remove';
    remove.setAttribute('aria-label', `Remove ${p.title || 'product'} from wishlist`);
    remove.addEventListener('click', () => {
      if (writeWishlist(readWishlist().filter(item => item.handle !== p.handle))) renderWishlist();
    });
    article.appendChild(remove);
    return article;
  }
  function renderWishlist() {
    const container = document.querySelector('[data-wellrobed-wishlist-items]');
    if (!container) return;
    container.replaceChildren();
    const items = readWishlist();
    if (!items.length) {
      const empty = document.createElement('div');
      empty.className = 'wellrobed-wishlist-empty';
      const message = document.createElement('p');
      message.textContent = 'Your wishlist is empty.';
      const link = document.createElement('a');
      link.href = '/collections/all';
      link.textContent = 'Explore our collection';
      empty.append(message, link);
      container.appendChild(empty);
      return;
    }
    const grid = document.createElement('div');
    grid.className = 'wellrobed-wishlist-items';
    items.forEach(p => grid.appendChild(productCard(p)));
    container.appendChild(grid);
  }
  function initialize() {
    syncHeader();
    attachProductButton();
    renderWishlist();
  }
  window.addEventListener('wellrobed:wishlist-changed', () => {
    syncHeader();
    document.querySelectorAll('[data-wellrobed-wishlist-save]').forEach(button => {
      const p = currentProduct();
      if (p) syncSaveButton(button, p);
    });
  });
  window.addEventListener('storage', e => {
    if (e.key === KEY) {
      syncHeader();
      renderWishlist();
    }
  });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
